import { Link } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";

export default function NotFoundPage() {
  usePageTitle("Not Found");
  return (
    <div className="text-center py-16" role="alert" aria-live="polite">
      <h1
        className="text-6xl font-bold text-gray-300 dark:text-dark-text-muted mb-4"
        aria-hidden="true"
      >
        404
      </h1>
      <h2 className="text-2xl font-semibold text-gray-700 dark:text-dark-text mb-4">
        Page Not Found
      </h2>
      <p className="text-gray-500 dark:text-dark-text-secondary mb-8">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/apps"
        className="inline-block bg-primary-500 text-white px-6 py-3 rounded-lg hover:bg-primary-600 dark:bg-primary-600 dark:hover:bg-primary-500 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-dark-bg"
      >
        Go Home
      </Link>
    </div>
  );
}
